import {
    BufferAttribute,
    InterleavedBufferAttribute,
    Mesh,
    MeshLambertMaterial,
    PlaneBufferGeometry,
    Scene,
    Texture,
    TextureLoader,
} from "three";
import { ImprovedNoise } from "three/examples/jsm/math/ImprovedNoise";

function generateMap(width: number, height: number): Uint8Array {
    const size = width * height;
    const data: Uint8Array = new Uint8Array(size);
    const perlin = new ImprovedNoise();
    let quality = 1;
    for (let j = 0; j < 4; j += 1) {
        for (let i = 0; i < size; i += 1) {
            const x = i % width;
            const y = Math.floor(i / width);
            data[i] += Math.abs(
                perlin.noise(x / quality, y / quality, 0) * quality * 1.75
            );
        }
        quality *= 5;
    }
    return data;
}

class Ground {
    public mesh: Mesh;

    constructor(scene: Scene, worldSize: number) {
        const worldVertexes = 128;
        const worldHeight = 0.2;
        const map = generateMap(worldVertexes, worldVertexes);
        const geometry: PlaneBufferGeometry = new PlaneBufferGeometry(
            worldSize,
            worldSize,
            worldVertexes - 1,
            worldVertexes - 1
        );
        geometry.rotateX(-Math.PI / 2);
        const vertices: BufferAttribute | InterleavedBufferAttribute =
            geometry.attributes.position;
        for (let i = 0; i < vertices.count; i += 1) {
            vertices.setY(
                i,
                map[i] * worldHeight
            ); /* vertices.getY(i) * worldHeight */
        }
        geometry.computeVertexNormals();

        const textureLoader: TextureLoader = new TextureLoader();

        const texture: Texture = textureLoader.load(
            `${process.env.ASSET_URL}/textures/map.png`
        );

        const material = new MeshLambertMaterial({
            map: texture,
        });

        this.mesh = new Mesh(geometry, material);
        scene.add(this.mesh);
    }
}

export default Ground;
